import React, { useState } from 'react'
import {FaBars, FaTimes} from 'react-icons/fa'
import { NavLink, Link } from 'react-router-dom'
import '../Styles/Home.css'
import '../Styles/navbar.css'
import logo from '../images/logo.svg'
import '../Styles/GlobalStyling.css'
import { FaBook, FaFire } from 'react-icons/fa'
import img1 from '../images/016-elearning.png'
import img2 from '../images/019-history.png'
import img3 from '../images/020-chemistry.png'
import img4 from '../images/018-math.png'
import img5 from '../images/003-engineering.png'
import Footer from '../sections/Footer'
import QuestionSection from '../sections/Question'

const Home = () => {
    const [clicked, setClicked] = useState(false)

    const HandleClick = () => setClicked(!clicked)
    return (
        <>
            {/* Navigation bar //////// */}
            <div className="navbar">
            
            <NavLink to="/" className="nav-logo">
                <img src={logo} alt="" className="logo" />
                <h3 className="logo-text">
                    WorkMate
                </h3>
            </NavLink>

            <div className="menu-icon" onClick={HandleClick}>
                {clicked ? <FaTimes/> : <FaBars/>}
            </div>

            <ul className={clicked ? 'menu active' : 'menu'}>
                <li className="nav-item" onClick={HandleClick}>
                    Link
                </li>
                <li className="nav-item" onClick={HandleClick}>
                    Link
                </li>
                <li className="nav-item" onClick={HandleClick}>
                   <NavLink to='/Mentor'>
                       Mentors
                   </NavLink>
                </li>
                <li className="nav-item" onClick={HandleClick}>
                <NavLink to='/Dashboard'>
                       Dashboard
                   </NavLink>
                </li>
                <li className="nav-item mobile" onClick={HandleClick}>
                    <Link to='/SignUp'>
                        Join Us
                    </Link>
                </li>
            </ul>
            <Link to='/SignUp' className="cta mobile">
                Join Us
            </Link>
        </div>
        {/* navigation bar end ////// */}

        <div className="main-body">
                <div className='hero-container'>
                    <div className="text-box">
                        <h2 className="heading">
                            Learn Anytime, Anywhere, and Accelerate Future
                        </h2>
                        <p className="text">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, sit quia magni exercitationem officiis id. Delectus iusto ullam sequi veritatis laudantium sit debitis eum dolores quas, maxime eos voluptas amet.
                        </p>
                        <div className="cta">
                            Get Started
                        </div>
                    </div>
                </div>

                <div className="about-container">
                    <div className="left">
                        <h3 className="heading">
                            Ask Questions <br/>
                            Get Help <br/>
                            Go Beyond
                        </h3>
                        <p className="text">
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Omnis qui maxime ducimus doloremque eos laborum vero itaque ipsam, autem corrupti accusamus? Dolorem at vitae provident, aliquam ipsam quas vero soluta?
                        </p>
                        <div className="cta">
                            Get Homework Help!
                        </div>

                    </div>
                    <div className="right">

                        
                        <div className="card">
                            <FaBook className='icon'/>
                            <h3 className="card-head">
                                Expert Tutors
                            </h3>
                            <p className="card-text">
                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. 
                            </p>
                        </div>


                        <div className="card">
                            <FaBook className='icon'/>
                            <h3 className="card-head">
                                Expert Tutors
                            </h3>
                            <p className="card-text">
                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. 
                            </p>
                        </div>


                        <div className="card">
                            <FaBook className='icon'/>
                            <h3 className="card-head">
                                Expert Tutors
                            </h3>
                            <p className="card-text">
                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. 
                            </p>
                        </div>


                        <div className="card">
                            <FaBook className='icon'/>
                            <h3 className="card-head">
                                Expert Tutors
                            </h3>
                            <p className="card-text">
                                Lorem ipsum dolor, sit amet consectetur adipisicing elit. 
                            </p>
                        </div>

                    </div>
                </div>

                <div className='focus-container'>
                    <div className="left">
                        <div className="icon-circle">
                            <img src={img2} alt="" className="icon icon1"/>
                            <img src={img3} alt="" className="icon icon2"/>
                            <img src={img1} alt="" className="icon icon-prime"/>
                            <img src={img4} alt="" className="icon icon4"/>
                            <img src={img5} alt="" className="icon icon5"/>
                        </div>
                    </div>
                    <div className="right">
                        <div className="card">
                            <h3 className="card-head">
                                Our Focus
                            </h3>
                            <p className="card-text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi nihil sint voluptatibus reiciendis dolores sapiente distinctio voluptatum in quia eos itaque sequi deserunt autem error, illo aperiam qui consequatur nulla magnam fugiat quisquam. Voluptates a tempore numquam earum quibusdam necessitatibus? Soluta harum iure qui omnis optio vitae quisquam molestias asperiores, officiis repellendus consectetur possimus similique quis deleniti dignissimos! Dicta, et accusantium magnam doloremque nihil perferendis placeat illo quos at molestias.
                            </p>
                        </div>
                    </div>
                </div>

                <div className='premium-container'>
                    <div className="text-box">
                        <h2 className="heading">
                            Booost Learning and FastTrack Your Progress with Workmate Premium
                        </h2>
                        <p className="text">
                            Access unlimied answrs faster
                        </p>

                        <ul className="benefits">
                            <li>
                                <FaFire className='icon'/>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </li>
                            <li>
                                <FaFire className='icon'/>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </li>
                            <li>
                                <FaFire className='icon'/>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </li>
                            <li>
                                <FaFire className='icon'/>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </li>
                        
                        </ul>
                        <div className="cta">
                            Upgrade Now!
                        </div>
                    </div>
                </div>
            </div>
            <QuestionSection/>
            <Footer/>
            
        </>
    )
}

export default Home
